<template>
  <BaseModal id="package-form" :value="true" @input="close">
    <div class="p-4 pt-8">
      <div class="grid grid-cols-3 gap-2">
        <div>
          <label class="text-lg font-bold">Package width</label>
          <input
            id="package-width"
            class="border border-gray-300 rounded-md w-full p-2 mb-4"
            placeholder="filter state"
            type="number"
            @click="selectAll"
            v-model="pkg.width"
          />
        </div>
        <div>
          <label class="text-lg font-bold">Package height</label>
          <input
            class="border border-gray-300 rounded-md w-full p-2 mb-4"
            placeholder="filter state"
            type="number"
            v-model="pkg.height"
            @click="selectAll"
          />
        </div>
        <div>
          <label class="text-lg font-bold">Package length</label>
          <input
            class="border border-gray-300 rounded-md w-full p-2 mb-4"
            placeholder="filter state"
            type="number"
            v-model="pkg.length"
            @click="selectAll"
          />
        </div>
      </div>
      <div>
        <!-- package type -->
        <label class="text-lg font-bold">Package type</label>
        <select
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          v-model="pkg.type"
        >
          <option value="box">Box</option>
          <option value="package">Package</option>
          <option value="pallet">Pallet</option>
          <option value="envelope">Envelope</option>
        </select>
      </div>
      <div>
        <label class="text-lg font-bold">Package weight</label>
        <input
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          placeholder="filter state"
          type="number"
          v-model="pkg.weight"
          @click="selectAll"
        />
      </div>
      <div>
        <label class="text-lg font-bold">Quantity</label>
        <input
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          placeholder="filter state"
          type="number"
          v-model="pkg.quantity"
          @click="selectAll"
        />
      </div>
      <div>
        <label class="text-lg font-bold">Notes</label>
        <textarea
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          placeholder="filter state"
          v-model="pkg.notes"
        ></textarea>
      </div>
      <button class="dark-button mt-4" @click="addPackage">Add package</button>
    </div>
  </BaseModal>
</template>
<script>
import { addItemToDispatchReceipt } from "@/api/DispatchReceiptService.js";
export default {
  name: "BasePackageForm",
  data() {
    return {
      pkg: {
        width: 0,
        height: 0,
        length: 0,
        weight: 0,
        notes: "",
        quantity: 1,
        type: "package"
      },
      addingPackage: false
    };
  },
  props: {
    receiptId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const input = document.getElementById("package-width");
      if (input) {
        input.focus();
        input.select();
      }
    });
  },
  methods: {
    addPackage() {
      if (this.addingPackage || !this.validatePackage()) {
        return;
      }
      this.addingPackage = true;
      addItemToDispatchReceipt(this.receiptId, this.pkg).then(() => {
        this.$toast.success("Package added");
        this.addingPackage = false;
        this.$emit("package-added");
        this.close();
      });
      console.log(this.pkg);
    },
    close() {
      this.$emit("close");
    },
    validatePackage() {
      if (
        this.pkg.width <= 0 ||
        this.pkg.height <= 0 ||
        this.pkg.length <= 0 ||
        this.pkg.weight <= 0
      ) {
        this.$toast.error("Please fill all fields");
        return false;
      }
      return true;
    },
    selectAll(event) {
      event.target.select();
    }
  }
};
</script>
<style lang="scss">
#package-form .modal-content {
  width: 80%;
  top: calc(50% - 200px);
  max-width: 600px;
  height: auto;
}
</style>
